import {
    type HeldPresentations,
    isAssistantAnswer,
    isUserMessage,
} from '@apps/web/features/phoebe_chat_v3/model/activity';
import {
    type NextStepAction,
    type ToolCompoundState,
} from '@apps/web/features/phoebe_chat_v3/registry/types';

export type NextStepsOffer = Readonly<{
    readonly answerOccurrenceId: string;
    readonly actions: ReadonlyArray<NextStepAction>;
}>;

/**
 * The offer is the newest suggestion presentation in the transcript, under
 * the answer the hold pass recorded for it. A message of either sender
 * after it ends the offer: the reader has moved on, or a newer answer
 * arrived without one. A suggestion with no answer of its own is not
 * offered — buttons alone read as a reply to the reader.
 */
export function selectNextStepsOffer(
    held: HeldPresentations,
    compoundStates: ReadonlyMap<string, ToolCompoundState>,
): NextStepsOffer | null {
    for (let index = held.inputs.length - 1; index >= 0; index -= 1) {
        const input = held.inputs[index];
        if (input === undefined) {
            continue;
        }
        if (isUserMessage(input) || isAssistantAnswer(input)) {
            return null;
        }
        if (input.kind !== 'activity_occurrence') {
            continue;
        }
        const presentation = compoundStates.get(input.occurrenceId)?.result
            ?.presentation;
        if (presentation?.kind !== 'next_steps') {
            continue;
        }
        const answerOccurrenceId = held.answerByOwnerId.get(input.occurrenceId);
        return answerOccurrenceId === undefined
            ? null
            : { answerOccurrenceId, actions: presentation.actions };
    }
    return null;
}
